export { default } from '@/screens/JoinLeagueScreen';

